<template>
  <div class="manpowerIndustryBox">
        <div class="solttionCon">
          <div class="solttionConItem">
            <div class="solttionConHead">
              <ul>
                <li></li>
                <li>行业痛点</li>
              </ul>
            </div>
            <div class="solutionList">
                <ul v-if="difficultList.length>0">
                  <li v-for="(item,index) in difficultList" :key="index">
                      <div><img :src="item.img"></div>
                      <dl>
                        <dt>{{item.title}}</dt>
                        <dd>{{item.content}}</dd>
                      </dl>
                  </li>
                </ul>
            </div>
          </div>
          <div class="solttionConItem">
            <div class="solttionConpor">
              <div class="solttionConHead">
                <ul>
                  <li></li>
                  <li>解决方案</li>
                </ul>
              </div>
              <div class="programBox">
                  <div class="programBoxHead">
                      <ul  class="items">
                        <li class="item">
                           <dl>
                             <dt><img src="../../../assets/images/solution/smrz_icon.png"></dt>
                             <dd>实名认证</dd>
                             <dd>
                               <ul>
                                 <li><span></span>活体识别</li>
                                 <li><span></span>公安验证</li>
                                 <li><span></span>银行卡验证</li>
                               </ul>
                             </dd>
                           </dl>
                        </li>
                        <img src="../../../assets/images/solution/arrow_img.png" class="line">
                        <li class="item">
                           <dl>
                             <dt><img src="../../../assets/images/solution/yyqd_icon.png"></dt>
                             <dd>意愿确定</dd>
                             <dd>
                               <ul>
                                 <li><span></span>登录密码</li>
                                 <li><span></span>签约密码</li>
                                 <li><span></span>短信核验</li>
                               </ul>
                             </dd>
                           </dl>
                        </li>
                        <img src="../../../assets/images/solution/arrow_img.png" class="line">
                        <li class="item">
                           <dl>
                             <dt><img src="../../../assets/images/solution/htqs_icon.png"></dt>
                             <dd>合同签署</dd>
                             <dd>
                               <ul>
                                 <li><span></span>合同在线签署</li>
                                 <li><span></span>公众平台接口</li>
                                 <li><span></span>私有化部署</li>
                               </ul>
                             </dd>
                           </dl>
                        </li>
                        <img src="../../../assets/images/solution/arrow_img.png" class="line">
                        <li class="item">
                           <dl>
                             <dt><img src="../../../assets/images/solution/czbq_icon.png"></dt>
                             <dd>存证保全</dd>
                             <dd>
                               <ul>
                                 <li><span></span>指纹存在</li>
                                 <li><span></span>原文存证</li>
                                 <li><span></span>证据保全</li>
                               </ul>
                             </dd>
                           </dl>
                        </li>
                        <img src="../../../assets/images/solution/arrow_img.png" class="line">
                        <li class="item">
                           <dl>
                             <dt><img src="../../../assets/images/solution/sjsl_icon.png"></dt>
                             <dd>数据上链</dd>
                             <dd>
                               <ul>
                                 <li><span></span>公证节点</li>
                                 <li><span></span>鉴定节点</li>
                                 <li><span></span>仲裁节点</li>
                                 <li><span></span>法院节点</li>
                               </ul>
                             </dd>
                           </dl>
                        </li>
                        <img src="../../../assets/images/solution/arrow_img.png" class="line">
                        <li class="item">
                           <dl>
                             <dt><img src="../../../assets/images/solution/sffz_icon.png"></dt>
                             <dd>司法辅助</dd>
                             <dd>
                               <ul>
                                 <li><span></span>合同模板</li>
                                 <li><span></span>律师服务</li>
                                 <li><span></span>公证鉴定</li>
                                 <li><span></span>纠纷解决</li>
                               </ul>
                             </dd>
                           </dl>
                        </li>
                      </ul>
                  </div>
                  <div class="programBoxCon">
                      <p>
                         对于人力资源行业，可通过智签电子签约平台由专业律师团队提供法律解读与劳动合同咨询、进行标准合同模板下载并签署合法合规的电子合同，同时，对人事合同签订过程中关键性证据进行存证，保障电子数据的真实性原始性，并利用区块链技术通过司法联盟链将数据同步至多家公证处、司法鉴定机构、仲裁机构以及互联网法院，保证电子数据可以作为证据被仲裁所采信。
                      </p>
                      <p>
                        人力资源行业解决方案提供实名认证、电子合同签署、电子数据存证、在线公证、在线司法鉴定、律师咨询等多元化的在线服务。为企业的标准人事流程建设、劳动合同签署、双方权利义务保障提供支撑，从而降低人力资源管理成本，提升工作效率。
                      </p>
                  </div>
              </div>

            </div>
          </div>
           <div class="solttionConItem">
              <div class="solttionConHead">
                <ul>
                  <li></li>
                  <li>特色保障</li>
                </ul>
              </div>
              <div class="guaranteeList">
                <ul>
                  <li v-for="(item,index) in guaranteeList" :key="index">
                    <div>
                        <img :src="item.img" class="BigImg">
                        <span class="icon" v-bind:style="{backgroundImage:'url(' + item.icon + ')'}"></span>
                    </div>
                    <dl>
                      <dt><span>{{item.title}}</span></dt>
                      <dd>{{item.content}}</dd>
                    </dl>
                  </li>
                </ul>
              </div>
           </div>
        </div>
    </div>
</template>
<script>
export default {
  data(){
    return{
      difficultList:[
        {
          img:require("../../../assets/images/solution/cbxld_icon.png"),
          title:"成本高效率低",
          content:"企业内部签署的合同数量逐年增长，导致了各类纸质文件需要专人管理，成本随之增长；且效率低下。"
        },
        {
          img:require("../../../assets/images/solution//kdyqsn_icon.png"),
          title:"跨地域签署难",
          content:"绝大多数企业存在异地签署劳动合同的问题，跨地签署流程繁琐，耗时长。"
        },
        {
          img:require("../../../assets/images/solution//safe_icon.png"),
          title:"安全性差",
          content:"因其自身的特点，纸质文件存在易丢失、易损毁的特点，一旦文件被损毁或者丢失，将会造成严重的后果。"
        },
        {
          img:require("../../../assets/images/solution/zjlbq_icon.png"),
          title:"证据链不全",
          content:"纸质合同的签署，很难拿出完整的证据链，存在毁约风险。"
        }
      ],
      guaranteeList:[
        {
          img:require("../../../assets/images/solution/legal_img.png"),
          icon:require('../../../assets/images/solution/legal_nor_icon.png.png'),
          title:"法律效力",
          content:"对接公安部、工商局、银联数据库进行实名认证，保障合同主体可信，采用数字证书，可信时间源等方式，保障合同司法效力。"
        },
        {
          img:require("../../../assets/images/solution/signcontrol_img.png"),
          icon:require('../../../assets/images/solution/signcontrol_pre_icon.png.png'),
          title:"签控一体",
          content:"签约、履约等全证据链全部通过司法联盟链进行存证，通过智能合约进行履约管控，控制违约风险，保障签约方的合法权益。"
        },
        {
          img:require("../../../assets/images/solution/judicial_img.png"),
          icon:require('../../../assets/images/solution/judicial_nor_icon.png'),
          title:"司法保障",
          content:"司法联盟链同步至多家公证处、司法鉴定机构，仲裁机构以及互联网法院，多方参与共识，保证电子数据作为证据的司法证明能力。"
        },
        {
          img:require("../../../assets/images/solution/jbzx_img.png"),
          icon:require('../../../assets/images/solution/jdcb_nor_icon.png'),
          title:"降本增效",
          content:"减少线下签署环节，减少人力、邮寄、纸质合同及管理成本。达到大幅度提高人力资源管理工作的效率并降低成本的目的。"
        },
      ],
    }
  }
}
</script>
<style lang="scss" >
.manpowerIndustryBox{
    width:100%;
    .solttionCon{
      .solttionConItem{
        width:1180px;
        padding-bottom:40px;
        margin:0 auto;
        .solttionConHead{
          width: 100%;
          overflow: hidden;
          padding-top: 40px;
          padding-bottom: 30px;
          li{
            float: left;
            line-height: 18px;
          }
          li:nth-child(1){
            height: 18px;
            width:4px;
            background: #B41C2E;
            margin-right: 10px;
          }
          li:nth-child(2){
            font-family: 'PingFangSC-Light';
            font-size: 18px;
            color: #464646;
          }
        }
        .solutionList{
          width:100%;
          height: 190px;
          li{
            width: calc((100% - 60px) / 4);
            height: 190px;
            float: left;
            display: flex;
            justify-content: space-between;
            flex-direction: column;
            margin-right: 20px;
            padding:20px;
            box-sizing: border-box;
            border: 1px solid rgb(235,235,235);
            div{
              text-align: right;
              img{
                width:48px;
                height: auto;
              }
            }
            dl{
              dt{
                font-size: 18px;
                color: #464646;
                font-weight: 550;
                margin-bottom: 10px;
              }
              dd{
                font-size: 13px;
                color: #787878;
                line-height: 19px;
                text-align: justify;
              }
            }
          }
          li:last-child{
            margin-right: 0;
          }
          li:hover{
            box-shadow: 0 2px 12px 0 rgba(0,0,0,0.20);
             border-color: #fff;
          }
        }
        .programBox{
          width:100%;
          overflow: hidden;
          .programBoxHead{
            width: 100%;
            .items{
              width:100%;
              height: 100%;
              display: flex;
              justify-content: space-around;
              align-items: flex-start;
              box-sizing: border-box;
              padding: 20px 64px;
              .item{ 
                dl{
                  text-align: center;
                  dt{
                    width: 60px;
                    height: 60px;
                    line-height: 60px;
                    background: #B41C2E;
                    border-radius: 12px;
                    margin: 0 auto;
                    margin-bottom: 12px;
                    img{
                      width:34px;
                      height: auto;
                      vertical-align: middle;
                         transition: all 1s;
                    }
                  }
                  dt:hover{
                    img{
                      transform:rotateY(360deg);
                    }
                  }
                  dd:nth-child(2){
                    margin-bottom: 10px;
                  }
                  dd{
                     font-size: 18px;
                    color: #787878;
                     li{
                        font-size: 14px;
                        color: #969696;
                        line-height: 20px;
                        text-align: justify;
                        span{
                          display: inline-block;
                          width: 3px;
                          height: 3px;
                          border-radius: 50%;
                           vertical-align: middle;
                           margin-right: 4px;
                          background-color: #787878;
                        }
                     }
                  }
                }
              }
            }
            .line{
              margin-top: 20px;
              width:106px;
              height: auto;
            }
          }
          .programBoxCon{
            width:100%;
            display:flex;
            justify-content:space-between;
            p{
              font-size: 14px;
              color: #969696;
              line-height: 24px;
              text-indent: 2em;
              text-align: justify;
              margin-bottom: 20px;
              background-color: #fff;
              padding: 40px;
              box-sizing: border-box;
            }
            p:nth-child(1){
              width:65%;
            }
            p:nth-child(2){
              width:calc(45% - 20px);
              margin-left: 20px;
            }
          }
        }
        .solttionConpor{
          max-width: 1180px;
          margin:0 auto;
        }
        .guaranteeList{
          width:100%;
          height: 328px;
          li{
            width: calc((100% - 78px) / 4);
            height: 328px;
            float: left;
            margin-right: 26px;
            box-sizing: border-box;
            padding:2px;
            border: 1px solid rgb(235,235,235);
            div{
              width:100%;
              height: 160px;
              position: relative;
              .BigImg{
                width:100%;
                height: 100%;
              }
              .icon{  
                position: absolute;
                top:50%;
                left:50%;
                margin-top:-19px;
                margin-left: -20px;
                width:40px;
                height: 38px;
                background-size:100% 100%;
              }
            }
            dl{
              dt{
                font-size: 18px;
                color: #464646;
                font-weight: 550;
                margin-top:11px;
                margin-bottom: 15px;
                text-align: center;
                span{
                  display: inline-block;
                  padding-bottom: 6px;
                  border-bottom: 2px solid #B4B4B4;
                }
              }
              dd{
                box-sizing: border-box;
                padding:0 16px;
                font-size: 14px;
                color: #787878;
                line-height: 21px;
                text-align: justify;
              }
            }
          }
          li:last-child{
            margin-right: 0;
          }
          li:hover{
            box-shadow: 0 2px 12px 0 rgba(0,0,0,0.20);
            border-color: #fff;
            dl dt span{
              border-color:#686868;
            }
          }
          li:nth-child(1):hover{
            div .icon{
              background-image:url('../../../assets/images/solution/legal_hov_icon.png')!important;
            }
          }
          li:nth-child(2):hover{
            div .icon{
              background-image:url('../../../assets/images/solution/signcontrol_hov_icon.png')!important;
            }
          }
          li:nth-child(3):hover{
            div .icon{
              background-image:url('../../../assets/images/solution/judicial_hov_icon.png.png')!important;
            }
          }
         li:nth-child(4):hover{
            div .icon{
              background-image:url('../../../assets/images/solution/jdcb_hov.png')!important;
            }
          }
        }
      }
      .solttionConItem:nth-child(2){
        width: 100%;
        background: #F3F2F2;
      }
      
    }

}


</style>
